import React from 'react';
import TextField from '@material-ui/core/TextField';

export const RenderTextField = ({input, label, meta: {touched, error}, ...custom}) => <TextField
  label={label}
  error={!!(touched && error)}
  {...input}
  {...custom}
/>;
